import { useCallback, useMemo, useState } from 'react';

import { ProductsSequenceProduct } from '../../../../common/contracts';

export const usePopupProducts = (isDailyBonus: boolean) => {
  const [dailyProducts, setDailyProducts] = useState<ProductsSequenceProduct[]>(
    []
  );
  const [postProducts, setPostProducts] = useState<ProductsSequenceProduct[]>(
    []
  );

  const productsList = useMemo(
    () => (isDailyBonus ? dailyProducts : postProducts),
    [isDailyBonus, dailyProducts, postProducts]
  );

  const addProduct = useCallback(
    (newProduct: ProductsSequenceProduct) => {
      if (isDailyBonus) {
        setDailyProducts((prev) => [...prev, newProduct]);
      } else {
        setPostProducts([newProduct]);
      }
    },
    [isDailyBonus]
  );

  const deleteProduct = useCallback(
    (productId: string) => {
      if (isDailyBonus) {
        setDailyProducts((prev) =>
          prev.filter((p) => p.productId !== productId)
        );
      } else {
        setPostProducts((prev) =>
          prev.filter((p) => p.productId !== productId)
        );
      }
    },
    [isDailyBonus]
  );

  const updateProduct = useCallback(
    (productId: string, newProductData: ProductsSequenceProduct) => {
      if (isDailyBonus) {
        setDailyProducts((prev) =>
          prev.map((p) =>
            p.productId === productId ? { ...p, ...newProductData } : p
          )
        );
      } else {
        setPostProducts((prev) =>
          prev.map((p) =>
            p.productId === productId ? { ...p, ...newProductData } : p
          )
        );
      }
    },
    [isDailyBonus]
  );

  return {
    productsList,
    addProduct,
    deleteProduct,
    updateProduct,
    setDailyProducts,
    setPostProducts
  };
};
